import { Users, Permissions, PasswordChange } from "../components/Accesos";

const routesAccesos = [
    {
        path: "/accesos-permissions",
        name: "Permisos",
        icon: "nc-icon nc-bank",
        component: <Permissions />,
        permissions: ['89_PERMISOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/accesos-usuarios",
        name: "Usuarios",
        icon: "nc-icon nc-bank",
        component: <Users />,
        permissions: ['90_USUARIOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
    },
    {
        path: "/cambiar-clave",
        name: "Usuarios",
        icon: "nc-icon nc-bank",
        component: <PasswordChange />,
        permissions: [],
        layout: "/app",
        visibility: false,
        subRoutes: [],
    }
]

export {
    routesAccesos
}